import experiments from "./Experiments.module.css";
import ExperimentCard from "../../components/experiments/ExperimentCard";
import cards from "../../data/ExperimentsData";

function Experiments() {
    return (
        <main id="experiments" className={experiments.experiments}>
            <h1 className={experiments.title}>EXPERIMENTS</h1>
            <h1 className={experiments.mobileTitle}>EXPS.</h1>
            <div className={experiments.cards}>
            {cards.map((card, index) => (
                <ExperimentCard
                    key={index}
                    number={cards.length - index}
                    h1={card.h1}
                    tags={card.tags}
                    cover={card.cover}
                    link={card.link}
                />
            ))}
            </div>
        </main>
    );
}

export default Experiments;
